import { Column, Index } from 'typeorm';

import { IsNumber } from '../../validators';
import { BasicEntity } from '../basic/basic.entity';

@Index(
  'billing__promo_activations__account_id__promo_registry_id',
  ['accountId', 'promoRegistryId'],
  {
    unique: true,
    where: '"deletedAt" is NULL',
  },
)
export class PromoActivations extends BasicEntity {
  @Column({ type: 'int', nullable: false })
  accountId: number;

  @Column({ type: 'int', nullable: false })
  promoRegistryId: number;

  @Column({ type: 'int', nullable: false, default: 0 })
  @IsNumber({}, { groups: ['error'] })
  coins: number;
}
